import { useEffect } from "react";
export default function LisPresta() { useEffect(() => { window.location.replace("/lispresta/"); }, []); return <p role="status">Abriendo LIS-Presta…</p>; }
